import { AloftDate, PolygonGeoSearch, SubjectData } from '@aloft/toolkit-shared';

import { useState } from 'react';

import { getDefaultRecommendedCompSearch } from '../utils/getDefaultRecommendedCompSearch.ts';
import { useRecommendedCompsForm } from './useRecommendedCompsForm.ts';

export const useRecommendedCompsInternalState = (
  subject: SubjectData,
  effectiveDate: AloftDate,
) => {
  const form = useRecommendedCompsForm({
    search: {
      filters: {},
      geoSearch: {
        t: 'polygon',
        coords: [],
      },
      matchCriteria: {},
    },
    originalSearch: {
      filters: {},
      geoSearch: {
        t: 'polygon',
        coords: [],
      },
      matchCriteria: {},
    },
  });

  const getGeoSearch = () => {
    const geoSearch = form.getValues('search.geoSearch');
    if (geoSearch.t !== 'polygon') {
      throw new Error('Radius search unsupported');
    }
    return geoSearch;
  };

  const setGeoSearch = (geoSearch: PolygonGeoSearch) => {
    form.setValue('search.geoSearch', geoSearch);
  };

  const getDefaultFormValues = () => getDefaultRecommendedCompSearch(subject, effectiveDate);

  const [showNoRecommendations, setShowNoRecommendations] = useState(false);

  return {
    form,
    getGeoSearch,
    setGeoSearch,
    showNoRecommendations,
    setShowNoRecommendations,
    getDefaultFormValues,
  };
};
